import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-restricted-access',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './restricted-access.component.html',
  styleUrl: './restricted-access.component.scss',
})
export class RestrictedAccessComponent {
  @Output() rsvpChange = new EventEmitter();

  constructor() {}

  onRsvp() {
    this.rsvpChange.emit();
  }
}
